   <div class="popup">
    <div class="popup-content">
      <div class="popup-header">
        <span class="close" (click)="onClose()">&times;</span>
      </div>
      <div class="popup-body">       
        <p><strong>File Upload Failed.</strong> &nbsp;{{ uploadAlertMsgFailed }} <Strong>{{ failedAtPercentage }}%</Strong> {{ uploadAlertMsg }}</p>
        
        <div class="radio-box">
            <div class="radio-item">
              <input
                type="radio"
                id="resume"
                name="radioValue"
                value="resume"
                (change)="radioHandlerEvent($event)"
              />
              <label for="resume">
                Resume <strong>(Recommended)</strong>
            </label>
              <label for="resume" class="radio-check"> </label>
            </div>
            <div class="radio-item">
              <input
                type="radio"
                id="new"
                name="radioValue"
                value="fresh_upload"
                (change)="radioHandlerEvent($event)"
              />
              <label for="new">New Upload</label>
              <label for="new" class="radio-check"> </label>
            </div>
          </div>
      </div>
    </div>
  </div>